import React from 'react';

// DEPRECATED: use src/components/form/Button.component.jsx
const Button = ({ buttonName, className, disabled, id, onClickButton }) => (
  <button
    data-bem="Button--settings"
    className={`btn btn-violet ${className || ''} ${disabled ? 'disabled' : ''}`}
    onClick={() => void onClickButton()}
    disabled={disabled}
    id={id}
  >
    <span className="plus-ico">+</span>
    {buttonName}
  </button>
);

Button.defaultProps = {
  className: '',
  buttonName: '',
  disabled: false,
  id: '',
};

export default Button;
